import { render } from "./Notifications.vue?vue&type=template&id=1f01b47e"
import script from "./Notifications.vue?vue&type=script&lang=js"
export * from "./Notifications.vue?vue&type=script&lang=js"

import "./Notifications.vue?vue&type=style&index=0&id=1f01b47e&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"webpack-assets/vue/templates/common/header/parts/Notifications.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1f01b47e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1f01b47e', __exports__)) {
    api.reload('1f01b47e', __exports__)
  }
  
  module.hot.accept("./Notifications.vue?vue&type=template&id=1f01b47e", () => {
    api.rerender('1f01b47e', render)
  })

}


export default __exports__